// Module
var code = "<h3>Organisations</h3> <div class=\"card\"> <h5>User Organisations</h5> </div> ";
// Exports
export default code;